import { createFileRoute } from '@tanstack/react-router'
import { KioskPage } from '@/app/face/kiosk'

/// /kiosk — the entrance camera (specs/access.md §6). Outside the signed-in
/// layout on purpose: a tablet by the door has a device key, not a staff
/// session, and shows no sidebar.
export const Route = createFileRoute('/kiosk')({
  component: KioskPage,
})
